import { DefinitionNode } from 'graphql';

import { assertUnreachable } from 'src/lib/assertUnreachable';
import { expandedPrint } from 'src/lib/expandedPrint';
import { DefinitionLookup } from 'src/lib/parseGraphqlMergedDefinitions';

import { Coordinate, SCHEMA_NAME } from './diffHelpers';

interface CoordinateType extends Pick<DefinitionNode, 'kind'> {
  printed: string;
  name: string;
}

export const getCoordinateType = (
  coordinate: Coordinate,
  definitions: DefinitionLookup | null,
): CoordinateType | undefined => {
  if ('schemaDefinition' in coordinate && 'schemaExtension' in coordinate) {
    if (!definitions?.schema) return;
    return {
      kind: definitions.schema.kind,
      name: SCHEMA_NAME,
      printed: expandedPrint(definitions.schema),
    };
  } else if ('directive' in coordinate) {
    const directiveDefinition = definitions?.directives.get(
      coordinate.directive,
    );
    if (!directiveDefinition) return;
    return {
      kind: directiveDefinition.kind,
      name: coordinate.directive,
      printed: expandedPrint(directiveDefinition),
    };
  } else if ('type' in coordinate) {
    const typeDefinition = definitions?.types.get(coordinate.type);
    if (!typeDefinition) return;
    return {
      kind: typeDefinition.kind,
      name: coordinate.type,
      printed: expandedPrint(typeDefinition),
    };
  } else {
    assertUnreachable(coordinate);
  }
};
